
<div class="login-app signed-out" >
  <div class="logo-login" >
    <div class="logo">
      <img src="assets/img/accesshublogo.png" alt="accesshublogo">
    </div>
  </div>

  <div class="center P10 PT30 login-body">
    <div class="sign-in">
      <h5 class="MB20">YOU HAVE SIGNED OUT</h5>
    </div>

    <div class="sign-out">
      <a routerLink= '/'>
        <i class="icon icon-back"></i>
        Go back to home page
      </a>
    </div>
  </div>
</div>
